'use es6';

import React from 'react';
import omit from '../utils/underscore/omit';
import { CARD_BACKGROUND } from './PageConstants';
import UIAbstractPageTemplate from './UIAbstractPageTemplate';

function UIDashboardPage(props) {
  return React.createElement(UIAbstractPageTemplate, Object.assign({}, props, {
    horizontalDivider: true,
    mainSectionBackgroundColor: CARD_BACKGROUND
  }));
}

UIDashboardPage.propTypes = omit(UIAbstractPageTemplate.propTypes, 'horizontalDivider', 'mainSectionBackgroundColor');
UIDashboardPage.defaultProps = omit(UIAbstractPageTemplate.defaultProps, 'horizontalDivider', 'mainSectionBackgroundColor');
UIDashboardPage.displayName = 'UIDashboardPage';
export default UIDashboardPage;